<template>
  <div class="pmw-selected-items-list-wrapper">
    <div class="pmw-selected-items-list">
      <!-- BUSCA -->
      <div class="pmw-selected-items-list-search-wrapper">
        <SearchInput
          v-model="filterModelValue"
          :placeholder="selectedPlaceholder"
          class="pmw-selected-items-list--search"
        />
      </div>

      <!-- LISTA -->
      <div v-if="items.length" class="pmw-selected-items-list-items">
        <PmwSelectedItem
          v-for="item in filteredListValue"
          :item="item"
          :itemIdKey="itemIdKey"
          :itemNameKey="itemNameKey"
          :key="`list-item-${item[itemIdKey]}`"
          @deleteItem="$emit('deleteItem', $event)"
        />
      </div>

      <!-- MENSAGEM LISTA VAZIA -->
      <div
        v-else
        class="pmw-selected-items-list-items pmw-selected-items-list-items__empty"
      >
        <PmwParagraph>{{ emptyMessage }}</PmwParagraph>
      </div>
    </div>

    <!-- CONTADOR -->
    <PmwParagraph class="pmw-selected-items-list--counter"
      >{{ `${items.length}`.padStart(2, '0') }} grupos
      selecionados</PmwParagraph
    >
  </div>
</template>

<script>
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput/SearchInput.vue'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph/PmwParagraph.vue'

const PmwSelectedItem = () =>
  import(/* webpackPrefetch: true */ './PmwSelectedItem.vue')

export default {
  name: 'PmwSelectedItemsList',

  components: {
    SearchInput,
    PmwParagraph,
    PmwSelectedItem
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },

    itemIdKey: {
      type: String,
      default: 'id'
    },

    itemSearchKey: {
      type: String,
      default: 'name'
    },

    itemNameKey: {
      type: String,
      default: 'name'
    },

    emptyMessage: {
      type: String,
      default: 'Nenhum item selecionado'
    },

    selectedPlaceholder: {
      type: String,
      default: 'Buscar item'
    }
  },

  data() {
    return {
      filterModelValue: '' /** Termo do filtro de busca */
    }
  },

  computed: {
    filteredListValue() {
      if (!this.filterModelValue.trim()) return this.items

      const rgxTerm = new RegExp(this.filterModelValue, 'gmi')

      return this.items.filter(
        (item) => item[this.itemSearchKey].search(rgxTerm) > -1
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-selected-items-list {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  min-width: 416px;
  height: 337px;
  border: 1px solid $gray-border;
  box-sizing: border-box;
  overflow-y: auto;

  &--search {
    padding: 0 pmw-space(2);
  }

  &-items {
    &__empty {
      display: grid;
      grid-auto-columns: max-content;
      grid-auto-rows: max-content;
      align-content: center;
      justify-content: center;
    }
  }

  &--counter {
    margin: pmw-space() 0 0;
    color: pmw-colors('grey-70');
    text-align: right;
  }
}
</style>
